export default __webpack_public_path__ + "static/bg-quiz-1c42c74bff050416caa6be90717d275d.png";